<template>
	<input v-bind:id="prop.id"
		   v-bind:dir="prop.display.direction"
		   v-on:change="onHandelChange"
		   v-on:keyup="onHandelKeyUp"
		   v-imask="mask"
		   type="text"
		   class="form-control"
		   autocomplete="off" />
</template>
<script>
	import { IMaskDirective } from 'vue-imask';
	export default {
		emits: ['change', 'keyup', 'submit'],

		props: {
			prop: {
				type: Object
			}
		},

		data()
		{
			return {
				value: null,
				mask: {
					mask: '{0000}`/{00}/`{00}',
					placeholderChar: '-',
					lazy: false,
				},
			}
		},

		beforeMount()
		{
			this.value = this.prop.value
		},

		methods: {

			onHandelChange()
			{
				this.$emit('change', this.value)
			},

			onHandelKeyUp(e) {
				if (e.key === 'Enter' || e.keyCode === 13) {
					this.$emit('submit')
				}
				else {
					this.$emit('keyup', this.value)
				}
			}
		},
		directives: {
			imask: IMaskDirective
		}
	}
</script>
